<template>
  <div>
    <h3 class="co-display-10 mb-2 border-b pb-4 text-center font-bold">
      <FontAwesomeIcon
        :icon="faCircleInfo"
        class="fa-fw mr-2 inline size-5 text-co-info-500"
      />
      分割払いをご利用いただけます
    </h3>
    <!-- //- 1つ表記 -->
    <div
      v-if="sorcial"
      class="co-display-10 mb-2 flex flex-col text-center"
    >
      <div class="w-full">
        <b class="font-normal">
          月々約
          <span class="co-display-6 px-2 font-bold">
            <template v-if="socialWeek8">
              {{ $addComma(social8WeeksPlanPriceDevidedBy24) }}
            </template>
            <template v-else-if="week12">
              {{ $addComma(social12WeeksPlanPriceDevidedBy24) }}
            </template>
            <template v-else>
              {{ $addComma(social24WeeksPlanPriceDevidedBy24) }}
            </template>
          </span>
          円〜
        </b>
      </div>
    </div>
    <!-- //- 社会人、学生表記 -->
    <div
      v-else
      class="co-display-10 mb-2 flex flex-col lg:flex-row lg:gap-x-8"
    >
      <div class="text-center lg:w-1/2">
        <b class="font-normal">
          社会人の方は月々約
          <span class="co-display-6 px-2 font-bold">
            <template v-if="week8">
              {{ $addComma(social8WeeksPlanPriceDevidedBy24) }}
            </template>
            <template v-else-if="week12">
              {{ $addComma(social12WeeksPlanPriceDevidedBy24) }}
            </template>
            <template v-else-if="week16">
              {{ $addComma(social16WeeksPlanPriceDevidedBy24) }}
            </template>
            <template v-else-if="week24">
              {{ $addComma(social24WeeksPlanPriceDevidedBy24) }}
            </template>
          </span>
          円〜
        </b>
      </div>
      <div class="text-center lg:w-1/2">
        <b class="font-normal">
          学生の方は月々約
          <span
            v-if="week8"
            class="co-display-6 px-2 font-bold"
          >
            {{ $addComma(student8WeeksPlanPriceDevidedBy24) }}
          </span>
          <span
            v-else-if="week12"
            class="co-display-6 px-2 font-bold"
          >
            {{ $addComma(student12WeeksPlanPriceDevidedBy24) }}
          </span>
          <span
            v-else-if="week16"
            class="co-display-6 px-2 font-bold"
          >
            {{ $addComma(student16WeeksPlanPriceDevidedBy24) }}
          </span>
          <span
            v-else-if="week24"
            class="co-display-6 px-2 font-bold"
          >
            {{ $addComma(student24WeeksPlanPriceDevidedBy24) }}
          </span>
          円〜
        </b>
      </div>
    </div>
    <p class="co-display-13 mb-1 text-center text-co-gray-500">
      ※上記の値段は
      <template v-if="week8 || socialWeek8">
        8週間プランを
      </template>
      <template v-else-if="week12">
        12週間プランを
      </template>
      <template v-else-if="week16">
        16週間プランを
      </template>
      <template v-else-if="week24">
        <!-- 24週間プランを -->
      </template>
      24回払いの場合となります。
    </p>
    <p class="co-display-13 mb-[3.25rem] text-center text-co-gray-500">
      ※分割手数料については、ご契約のカード会社によって異なりますので、直接カード会社にお問い合わせください。
    </p>
    <!-- クラウドローンバナー -->
    <!-- Educareテスト開始、クラウドローンバナーはコメントアウト -->
    <!-- <TeCommonBannerCrowdloan /> -->
  </div>
</template>

<script lang="ts">
import TeCommonBannerCrowdloan from '~/components/Te/TeCommon/Banner/Crowdloan/TeCommonBannerCrowdloan.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleInfo } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  pack: any
}

const options = {
  async setup() {
    return {
      faCircleInfo,
    }
  },
  props: {
    pack: {
      default: null,
    },
    week8: {
      type: Boolean,
      default: false,
    },
    week12: {
      type: Boolean,
      default: false,
    },
    week16: {
      type: Boolean,
      default: false,
    },
    week24: {
      type: Boolean,
      default: false,
    },
    socialWeek8: {
      type: Boolean,
      default: false,
    },
    sorcial: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    addComma(value: number) {
      return value ? value.toLocaleString() : '-'
    },
  },
  computed: {
    social8WeeksPlanPriceDevidedBy24(): number | string {
      return this.pack
        ? Math.ceil(this.pack.attributes.standard_week8_price / 24)
        : '-';
    },
    student8WeeksPlanPriceDevidedBy24(): number | string {
      return this.pack
        ? Math.ceil(this.pack.attributes.student_week8_price / 24)
        : '-';
    },
    social12WeeksPlanPriceDevidedBy24(): number | string {
      return this.pack
        ? Math.ceil(this.pack.attributes.standard_week12_price / 24)
        : '-';
    },
    student12WeeksPlanPriceDevidedBy24(): number | string {
      return this.pack
        ? Math.ceil(this.pack.attributes.student_week12_price / 24)
        : '-';
    },
    social16WeeksPlanPriceDevidedBy24(): number | string {
      return this.pack
        ? Math.ceil(this.pack.attributes.standard_week16_price / 24)
        : '-';
    },
    student16WeeksPlanPriceDevidedBy24(): number | string {
      return this.pack
        ? Math.ceil(this.pack.attributes.student_week16_price / 24)
        : '-';
    },
    social24WeeksPlanPriceDevidedBy24(): number | string {
      return this.pack
        ? Math.ceil(this.pack.attributes.standard_week24_price / 24)
        : '-';
    },
    student24WeeksPlanPriceDevidedBy24(): number | string {
      return this.pack
        ? Math.ceil(this.pack.attributes.student_week24_price / 24)
        : '-';
    },
  },
  components: {
    TeCommonBannerCrowdloan,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
